import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';

export const MachineGroupCheckboxes = ({ groups, selectedGroups, onGroupChange }) => {
  const handleCheckboxChange = (groupName, checked) => {
    let newSelection = [...selectedGroups];
    
    if (groupName === 'all') {
      if (checked) {
        newSelection = ['all'];
      } else {
        // When unchecking 'all', don't select anything by default
        newSelection = [];
      }
    } else {
      if (checked) {
        // Remove 'all' if selecting specific group
        newSelection = newSelection.filter(g => g !== 'all');
        newSelection.push(groupName);
      } else {
        newSelection = newSelection.filter(g => g !== groupName);
      }
      
      // If nothing selected after unchecking, default to 'all'
      if (newSelection.length === 0) {
        newSelection = ['all'];
      }
    }
    
    onGroupChange(newSelection);
  };

  const isAllSelected = selectedGroups.includes('all');

  return (
    <Card className="p-4 rounded-sm border-border">
      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="group-all"
            checked={isAllSelected}
            onCheckedChange={(checked) => handleCheckboxChange('all', checked)}
            data-testid="checkbox-all"
          />
          <Label
            htmlFor="group-all"
            className="text-sm font-semibold uppercase tracking-wide cursor-pointer"
          >
            All Groups
          </Label>
        </div>
        
        <div className="h-px bg-border" />
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {groups.map((group) => (
            <div key={group.name} className="flex items-center space-x-2">
              <Checkbox
                id={`group-${group.name}`}
                checked={!isAllSelected && selectedGroups.includes(group.name)}
                onCheckedChange={(checked) => handleCheckboxChange(group.name, checked)}
                data-testid={`checkbox-${group.name.toLowerCase().replace(/\s+/g, '-')}`}
              />
              <Label
                htmlFor={`group-${group.name}`}
                className="text-xs uppercase tracking-wide cursor-pointer"
              >
                {group.name}
                <span className="text-muted-foreground ml-1">({group.count})</span>
              </Label>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};
